// extracted by mini-css-extract-plugin
export default {"closeButton":"closeButton_J5rP"};